import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router, Route, IndexRoute, browserHistory } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';
import { load } from 'redux-load-api';
import _ from 'lodash';
import url from 'url';
import { clearBank } from './redux/modules/bank';
import { clearForms } from './redux/modules/form';
import { notifClearAll } from './redux/modules/notifs';
import { infoDismiss } from './redux/modules/info';
import store from './redux/store';
import { AuthProvider, makeRouterRedirects } from './components/Auth';
import App from './containers/App';
import { ProfilePage, ProfileCompletePopup } from './containers/Profile';
import GuestPayment from './containers/GuestPayment';
import Home from './containers/Home';
import NotFound from './containers/NotFound';
import OperationComplete from './containers/OperationComplete';
import Statements from './containers/Statements';
import Payment from './containers/Payment';
import ManagePayments from './containers/ManagePayments';
import SaveAccount from './containers/SaveAccount';
import UserAdmin from './containers/UserAdmin';
import UploadBankCsv from './containers/UploadBankCsv';
import { CacheAdmin } from './containers/CacheAdmin';
import * as storage from './utils/storage';

import './index.css';
import UploadAddressCsv from './containers/UploadAddressCsv';

// Enhanced history
const history = syncHistoryWithStore(browserHistory, store);

const { userAuth, prcoAdminAuth } = makeRouterRedirects();

const onRouteChange = () => {
  const { pathname, query } = url.parse(window.location.href, true);
  store.dispatch(notifClearAll());
  store.dispatch(infoDismiss());
  store.dispatch(clearForms());
  store.dispatch(clearBank());
  window.scrollTo(0, 0);

  // NOTE - We clear storage of these params when the home page is hit without the query
  if (pathname === '/' && !_.get(query, 'payment')) {
    storage.remove('paymentQuery');
  }

  // NOTE - Scrolling to top of the page
  if (_.isFunction(_.get(window, 'parent.postMessage'))) {
    window.parent.postMessage('SCROLL_TOP', '*');
  }
};

load([App]);

// TODO: Use dash case for routes
ReactDOM.render(
  <Provider store={store}>
    <AuthProvider>
      <ProfileCompletePopup />
      <Router history={history}>
        <Route path="/" component={App} onChange={onRouteChange}>
          {/* Unauthenticated Routes */}
          <IndexRoute component={Home} />
          <Route path="guestPayment" component={GuestPayment} />
          <Route path="operationComplete" component={OperationComplete} />

          {/* Authenticated Routes */}
          <Route path="statements" component={userAuth(Statements)} />
          <Route path="payment" component={userAuth(Payment)} />
          <Route path="saveAccount" component={userAuth(SaveAccount)} />
          <Route path="payments" component={userAuth(ManagePayments)} />
          <Route path="profile" component={userAuth(ProfilePage)} />

          {/* Admin Routes */}
          <Route path="admin/users" component={prcoAdminAuth(UserAdmin)} />
          <Route path="admin/upload-bank-csv" component={prcoAdminAuth(UploadBankCsv)} />
          <Route path="admin/upload-address-csv" component={prcoAdminAuth(UploadAddressCsv)} />
          <Route path="admin/cache" component={prcoAdminAuth(CacheAdmin)} />

          {/* Catch all route */}
          <Route path="*" component={NotFound} status={404} />
        </Route>
      </Router>
    </AuthProvider>
  </Provider>,
  document.getElementById('root'),
);
